/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { isNil } from 'ramda';
import { useDispatch } from 'react-redux';
import BidRequestRepository from 'repositories/loanOfficer/BidRequestRepository';

const initialState = {
  loading: false,
  bidRequest: {},
  bid: {},
  bidsFormInputValues: {},
  bidLoading: false,
};

const bidSlice = createSlice({
  name: 'bidSlice',
  initialState,
  reducers: {
    loadBidRequestStart(state) {
      state.loading = true;
    },
    loadBidRequestSuccess(state, { payload }) {
      const {
        data: {
          id,
          attributes: { bid, ...bidRequest },
        },
      } = payload;
      const { id: bidId, attributes } = bid;

      state.loading = false;
      state.bidRequest = { id: Number(id), ...bidRequest };
      state.bid = isNil(bidId) ? {} : { id: Number(bidId), ...attributes };
    },
    loadBidRequestFail(state) {
      state.loading = false;
    },
    createBidStart(state) {
      state.bidLoading = true;
    },
    createBidSuccess(state) {
      state.bidLoading = false;
    },
    createBidFail(state) {
      state.bidLoading = false;
    },
    setBidFormInputValues(state, { payload }) {
      const { bidRequestId, values } = payload;
      state.bidsFormInputValues[bidRequestId] = values;
    },
    changeBidFormInputValue(state, { payload }) {
      const { bidRequestId, field, value } = payload;
      const bid = state.bidsFormInputValues[bidRequestId];
      bid[field] = value;
    },
  },
});

export const { actions } = bidSlice;

export default bidSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const loadBidRequest = async bidRequestId => {
    dispatch(actions.loadBidRequestStart());
    try {
      const response = await BidRequestRepository.show(bidRequestId);
      dispatch(actions.loadBidRequestSuccess(response));
    } catch (_error) {
      dispatch(actions.loadBidRequestFail());
    }
  };

  const setBidFormInputValues = params => {
    dispatch(actions.setBidFormInputValues(params));
  };

  const changeBidFormInputValue = params => {
    dispatch(actions.changeBidFormInputValue(params));
  };

  const createBid = async params => {
    dispatch(actions.createBidStart());
    try {
      const response = await BidRequestRepository.post(params);
      dispatch(actions.createBidSuccess(response));
      return response;
    } catch (error) {
      dispatch(actions.createBidFail());
      return Promise.reject(error);
    }
  };

  return {
    loadBidRequest,
    setBidFormInputValues,
    changeBidFormInputValue,
    createBid,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/bidSlice.js